export const CRM_COLUMNS = [
  { key: "query_start_date", label: "查询起始日期" },
  { key: "query_end_date", label: "查询截止日期" },
  { key: "document_number", label: "单据号" },
  { key: "document_date", label: "单据日期" },
  { key: "vendor_code", label: "供应商编码" },
  { key: "vendor_name", label: "供应商名称" },
  { key: "description", label: "描述" },
  { key: "amount", label: "金额" },
  { key: "total_amount", label: "总金额" },
  { key: "status", label: "状态" },
  { key: "approver", label: "审批人" },
];